import { DateTime } from 'luxon';
import getOpenHouseDateTimeFromRepliersTREBInfo from '../helpers/repliersData/getOpenHouseDateTimeFromRepliersTREBInfo';
import { RepliersOpenHouse } from './repliers/RepliersOpenHouse';
import {
  ITSO_BOARD_RESOURCE_CODE,
  TORONTO_BOARD_RESOURCE_CODE,
} from '../constants/realEstateBoards';

export type OpenHouseObject = {
  start: string;
  end: string;
  listingTimezone: string;
};

export class OpenHouse {
  start: DateTime;
  end: DateTime;
  listingTimezone: string;

  constructor(start: DateTime, end: DateTime, listingTimezone: string) {
    this.start = start;
    this.end = end;
    this.listingTimezone = listingTimezone;
  }

  static fromObject(openHouseObject: OpenHouseObject): OpenHouse {
    const start = DateTime.fromISO(openHouseObject.start).toUTC();
    const end = DateTime.fromISO(openHouseObject.end).toUTC();

    return new OpenHouse(start, end, openHouseObject.listingTimezone);
  }

  static fromRepliersOpenHouseAndListingTimezone(
    repliersOpenHouse: RepliersOpenHouse,
    listingTimezone: string,
    resource: string,
  ): OpenHouse {
    let start;
    let end;
    if (resource === TORONTO_BOARD_RESOURCE_CODE) {
      start = getOpenHouseDateTimeFromRepliersTREBInfo(
        repliersOpenHouse.date,
        repliersOpenHouse.startTime,
        listingTimezone,
      );
      end = getOpenHouseDateTimeFromRepliersTREBInfo(
        repliersOpenHouse.date,
        repliersOpenHouse.endTime,
        listingTimezone,
      );
    } else if (resource === ITSO_BOARD_RESOURCE_CODE) {
      start = DateTime.fromISO(repliersOpenHouse.startTime).toUTC();
      end = DateTime.fromISO(repliersOpenHouse.endTime).toUTC();
    } else {
      throw new Error('Unsupported real estate board resource');
    }

    return new OpenHouse(start, end, listingTimezone);
  }

  occursInFuture() {
    return DateTime.now() < this.end;
  }

  formattedDate() {
    return this.start.setZone(this.listingTimezone).toFormat('EEE, MMM d');
  }

  formattedTimeInterval() {
    const humanizedStartTime = this.start
      .setZone(this.listingTimezone)
      .toFormat('h:mma');
    const humanizedEndTime = this.end
      .setZone(this.listingTimezone)
      .toFormat('h:mma');

    return `${humanizedStartTime} - ${humanizedEndTime}`;
  }

  formattedDateAndTimeInterval() {
    return `${this.formattedDate()}    ${this.formattedTimeInterval()}`;
  }

  toObject() {
    return {
      start: this.start.toString(),
      end: this.end.toString(),
      listingTimezone: this.listingTimezone,
    };
  }
}
